import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_MAX_LENGTHS, FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { KeyEventsRow } from 'components/BusinessToolForm/Sections/AboutCompany/CompanyHistory/components/KeyEventsRow';
import {
  ABOUT_COMPANY_HISTORY_NAMES,
  listOfKeyEventsInitialValues,
  prefix,
} from 'components/BusinessToolForm/Sections/AboutCompany/CompanyHistory/utils/form';

import { concatWithDot } from 'helpers/string';

export const CompanyHistoryProject: React.FC = () => {
  const { t } = useTranslation();

  const canAccess = true;

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t(`chapters.${FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT}`)}
          badgeText={t('company.history.title')}
          section={FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('company.history.events')}
        // aiFieldName={concatWithDot(prefix, ABOUT_COMPANY_HISTORY_NAMES.EVENTS)}
        // aiFieldType="complex"
        collapsible
      >
        <FieldArrayComponent
          name={concatWithDot(prefix, ABOUT_COMPANY_HISTORY_NAMES.EVENTS)}
          initialItem={listOfKeyEventsInitialValues}
          buttonText={t('keyEvent')}
          disabled={!canAccess}
        >
          {(namePrefix) => (
            <KeyEventsRow
              maxLength={FOR_INVESTORS_MAX_LENGTHS.COMPANY_HISTORY.EVENT}
              hiddenLabel
              multiline
              name={namePrefix}
              disabled={!canAccess}
            />
          )}
        </FieldArrayComponent>
      </FormSectionCard>
    </>
  );
};
